import moment from 'moment'
import isString from 'lodash/isString'

import config from '@/config'

const { dateFormat: { api: apiDateFormat, client: clientDateFormat } } = config

const allowedDateFormats = [apiDateFormat, clientDateFormat]

const dateTokenPatterns = {
  YYYY: '\\d{4}',
  YY: '\\d{2}',
  MM: '\\d{1,2}',
  DD: '\\d{1,2}',
}

const buildFormatPattern = (format) => format.replace(
  /YYYY|YY|MM|DD|[\s\S]/g,
  (token) => dateTokenPatterns[token] || token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
)

export const parseClientDate = (value, format = clientDateFormat) => {
  if (!isString(value) || !value.trim()) {
    return { status: 'incomplete', value: null }
  }

  // A two-digit year (29.09.26) is valid input: moment's YY windowing maps ≤ 68 to 20xx and ≥ 69 to 19xx.
  const candidateFormats = format.includes('YYYY') ? [format, format.replace('YYYY', 'YY')] : [format]
  const matchedFormat = candidateFormats.find(
    (candidate) => new RegExp(`^${buildFormatPattern(candidate)}$`).test(value),
  )

  if (!matchedFormat) {
    return { status: 'incomplete', value: null }
  }

  const date = moment(value, matchedFormat)
  return date.isValid()
    ? { status: 'valid', value: date.format(apiDateFormat) }
    : { status: 'invalid', value: null }
}

export const convertDateToApiDateFormat = (date) => {
  if (!date) return null
  const result = moment(date, allowedDateFormats)
  if (!result.isValid) {
    return null
  }
  return result.format(apiDateFormat)
}

export const formatDate = (date, originalFormat, expectedFormat) => {
  originalFormat = originalFormat || config.dateFormat.api
  expectedFormat = expectedFormat || config.dateFormat.client
  return date ? moment(date, originalFormat).format(expectedFormat) : ''
}

export const formatDateTime = (date, format = config.dateFormat.dateTime) => {
  if (!date) { return }
  return moment(date).format(format)
}

export const formatDateTime24 = (date) => {
  return formatDateTime(date, config.datetimeFormat.dateTime24)
}

export const getMonthName = monthIndex => {
  return config.monthNames[new Date().getMonth() + monthIndex]
}

export const formatTime = (date, format = 'HH:mm') => {
  if (!date) { return }
  return moment(date).format(format)
}

export const getCalendarDate = (date) => {
  return moment.utc(date).local().calendar(null, {
    lastDay: '[Gestern], HH:mm',
    sameDay: '[Heute], HH:mm',
    sameElse: config.dateFormat.dateTime,
    lastWeek: config.dateFormat.dateTime,
  })
}
